// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/avasta.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/avasta.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/avasta.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/avasta.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/avasta.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------

avasta Web Font
Generated using nucleoapp.com

-------------------------------- */
@font-face {
  font-family: 'avasta';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.icon {
  display: inline-block;
  font: normal normal normal 1em/1 'avasta';
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/*------------------------
  change icon size
-------------------------*/
/* relative units */
.icon-sm {
  font-size: 0.8em;
}
.icon-lg {
  font-size: 1.2em;
}
/* absolute units */
.icon-16 {
  font-size: 16px;
}
.icon-32 {
  font-size: 32px;
}
/*----------------------------------
  add a square/circle background
-----------------------------------*/
.icon-bg-square,
.icon-bg-circle {
  padding: 0.35em;
  background-color: #eee;
}
.icon-bg-circle {
  border-radius: 50%;
}
/*------------------------------------
  use icons as list item markers
-------------------------------------*/
.icon-ul {
  padding-left: 0;
  list-style-type: none;
}
.icon-ul > li {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
}
.icon-ul > li > .icon {
  margin-right: 0.4em;
  line-height: inherit;
}
/*------------------------
  spinning icons
-------------------------*/
.icon-is-spinning {
  animation: icon-spin 2s infinite linear;
}
@keyframes icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.icon-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}
.icon-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}
.icon-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}
.icon-flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}
.icon-flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}
/*------------------------
	icons
-------------------------*/

.icon-cloud-download-95::before {
  content: "\\ea02";
}

.icon-home-minimal::before {
  content: "\\ea03";
}

.icon-single-04::before {
  content: "\\ea04";
}

.icon-users-mm::before {
  content: "\\ea05";
}

.icon-webpage::before {
  content: "\\ea06";
}

.icon-layout-25::before {
  content: "\\ea07";
}

.icon-analytics::before {
  content: "\\ea08";
}

.icon-chart-pie-36::before {
  content: "\\ea09";
}

.icon-chart-bar-33::before {
  content: "\\ea0a";
}

.icon-single-copy-06::before {
  content: "\\ea0b";
}

.icon-home::before {
  content: "\\ea0c";
}

.icon-single-content-03::before {
  content: "\\ea0d";
}

.icon-bell-53::before {
  content: "\\ea0e";
}

.icon-email-84::before {
  content: "\\ea0f";
}

.icon-send::before {
  content: "\\ea10";
}

.icon-at-sign::before {
  content: "\\ea11";
}

.icon-attach-87::before {
  content: "\\ea12";
}

.icon-edit-72::before {
  content: "\\ea13";
}

.icon-tail-right::before {
  content: "\\ea14";
}

.icon-minimal-right::before {
  content: "\\ea15";
}

.icon-tail-left::before {
  content: "\\ea16";
}

.icon-minimal-left::before {
  content: "\\ea17";
}

.icon-tail-up::before {
  content: "\\ea18";
}

.icon-minimal-up::before {
  content: "\\ea19";
}

.icon-minimal-down::before {
  content: "\\ea1a";
}

.icon-tail-down::before {
  content: "\\ea1b";
}

.icon-settings-gear-64::before {
  content: "\\ea1c";
}

.icon-settings::before {
  content: "\\ea1d";
}

.icon-menu-dots::before {
  content: "\\ea1e";
}

.icon-menu-left::before {
  content: "\\ea1f";
}

.icon-funnel-40::before {
  content: "\\ea20";
}

.icon-filter::before {
  content: "\\ea21";
}

.icon-preferences-circle::before {
  content: "\\ea22";
}

.icon-check-2::before {
  content: "\\ea23";
}

.icon-cart-simple::before {
  content: "\\ea24";
}

.icon-cart-9::before {
  content: "\\ea25";
}

.icon-card-update::before {
  content: "\\ea26";
}

.icon-basket::before {
  content: "\\ea27";
}

.icon-check-circle-07::before {
  content: "\\ea28";
}

.icon-simple-remove::before {
  content: "\\ea29";
}

.icon-circle-remove::before {
  content: "\\ea2a";
}

.icon-alert-circle-exc::before {
  content: "\\ea2b";
}

.icon-bug::before {
  content: "\\ea2c";
}

.icon-share-66::before {
  content: "\\ea2d";
}

.icon-time-3::before {
  content: "\\ea2e";
}

.icon-time::before {
  content: "\\ea2f";
}

.icon-coffee::before {
  content: "\\ea30";
}

.icon-smile::before {
  content: "\\ea31";
}

.icon-sad::before {
  content: "\\ea32";
}

.icon-broken-heart::before {
  content: "\\ea33";
}

.icon-heart-2::before {
  content: "\\ea34";
}

.icon-pin-3::before {
  content: "\\ea35";
}

.icon-marker-3::before {
  content: "\\ea36";
}

.icon-globe-2::before {
  content: "\\ea37";
}

.icon-world-2::before {
  content: "\\ea38";
}

.icon-phone-2::before {
  content: "\\ea39";
}

.icon-check-square-11::before {
  content: "\\ea3a";
}

.icon-wallet-90::before {
  content: "\\ea3b";
}

.icon-credit-card::before {
  content: "\\ea3c";
}

.icon-payment::before {
  content: "\\ea3d";
}

.icon-tag::before {
  content: "\\ea3e";
}

.icon-tag-cut::before {
  content: "\\ea3f";
}

.icon-tag-content::before {
  content: "\\ea40";
}

.icon-flag-diagonal-33::before {
  content: "\\ea41";
}

.icon-triangle-right-17::before {
  content: "\\ea47";
}

.icon-puzzle-10::before {
  content: "\\ea48";
}

.icon-triangle-right-17-2::before {
  content: "\\ea49";
}

.icon-btn-play::before {
  content: "\\ea4a";
}

.icon-btn-play-2::before {
  content: "\\ea4b";
}

.icon-menu-34::before {
  content: "\\ea4c";
}

.icon-menu-left-2::before {
  content: "\\ea4d";
}

.icon-heart-2-2::before {
  content: "\\ea4e";
}

.icon-single-04-2::before {
  content: "\\ea4f";
}

.icon-users-mm-2::before {
  content: "\\ea50";
}

.icon-l-settings::before {
  content: "\\ea51";
}

.icon-book-open-2::before {
  content: "\\ea52";
}

.icon-layers-3::before {
  content: "\\ea53";
}

.icon-logo-fb-simple::before {
  content: "\\ea55";
}

.icon-logo-twitter::before {
  content: "\\ea56";
}

.icon-google::before {
  content: "\\ea57";
}

.icon-logo-pinterest::before {
  content: "\\ea58";
}

.icon-logo-instagram::before {
  content: "\\ea59";
}

.icon-logo-dribbble::before {
  content: "\\ea5a";
}

.icon-tablet-mobile::before {
  content: "\\ea5b";
}

.icon-house-search-engine::before {
  content: "\\ea5c";
}

.icon-house-pricing::before {
  content: "\\ea5d";
}

.icon-pulse-chart::before {
  content: "\\ea5e";
}

.icon-plug::before {
  content: "\\ea5f";
}

.icon-app-store::before {
  content: "\\ea60";
}

.icon-power-level::before {
  content: "\\ea61";
}

.icon-window-add::before {
  content: "\\ea62";
}

.icon-form::before {
  content: "\\ea63";
}

.icon-folder-15::before {
  content: "\\ea64";
}

.icon-lock::before {
  content: "\\ea65";
}

.icon-unlocked::before {
  content: "\\ea66";
}

.icon-e-reader::before {
  content: "\\ea67";
}

.icon-layout-grid::before {
  content: "\\ea68";
}

.icon-single-copies::before {
  content: "\\ea69";
}

`, "",{"version":3,"sources":["webpack://./src/icons/avasta/css/style.css"],"names":[],"mappings":"AAAA;;;;;kCAKkC;AAClC;EACE,qBAAqB;EACrB,4CAA+B;EAC/B,4SAA8O;EAC9O,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;0BAE0B;AAC1B;EACE,qBAAqB;EACrB,yCAAyC;EACzC,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;0BAE0B;AAC1B,mBAAmB;AACnB;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;oCAEoC;AACpC;;EAEE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;;sCAEsC;AACtC;EACE,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;0BAE0B;AAC1B;EAGE,uCAAuC;AACzC;AAiBA;EACE;IAKE,uBAAuB;EACzB;EACA;IAKE,yBAAyB;EAC3B;AACF;AACA;;0BAE0B;AAC1B;EACE,gEAAgE;EAKhE,wBAAwB;AAC1B;AACA;EACE,gEAAgE;EAKhE,yBAAyB;AAC3B;AACA;EACE,gEAAgE;EAKhE,yBAAyB;AAC3B;AACA;EACE,gEAAgE;EAKhE,uBAAuB;AACzB;AACA;EACE,gEAAgE;EAKhE,uBAAuB;AACzB;AACA;;0BAE0B;;AAE1B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/*--------------------------------\n\navasta Web Font\nGenerated using nucleoapp.com\n\n-------------------------------- */\n@font-face {\n  font-family: 'avasta';\n  src: url('../fonts/avasta.eot');\n  src: url('../fonts/avasta.eot') format('embedded-opentype'), url('../fonts/avasta.woff2') format('woff2'), url('../fonts/avasta.woff') format('woff'), url('../fonts/avasta.ttf') format('truetype'), url('../fonts/avasta.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.icon {\n  display: inline-block;\n  font: normal normal normal 1em/1 'avasta';\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/*------------------------\n  change icon size\n-------------------------*/\n/* relative units */\n.icon-sm {\n  font-size: 0.8em;\n}\n.icon-lg {\n  font-size: 1.2em;\n}\n/* absolute units */\n.icon-16 {\n  font-size: 16px;\n}\n.icon-32 {\n  font-size: 32px;\n}\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.icon-bg-square,\n.icon-bg-circle {\n  padding: 0.35em;\n  background-color: #eee;\n}\n.icon-bg-circle {\n  border-radius: 50%;\n}\n/*------------------------------------\n  use icons as list item markers\n-------------------------------------*/\n.icon-ul {\n  padding-left: 0;\n  list-style-type: none;\n}\n.icon-ul > li {\n  display: flex;\n  align-items: flex-start;\n  line-height: 1.4;\n}\n.icon-ul > li > .icon {\n  margin-right: 0.4em;\n  line-height: inherit;\n}\n/*------------------------\n  spinning icons\n-------------------------*/\n.icon-is-spinning {\n  -webkit-animation: icon-spin 2s infinite linear;\n  -moz-animation: icon-spin 2s infinite linear;\n  animation: icon-spin 2s infinite linear;\n}\n@-webkit-keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@keyframes icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.icon-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.icon-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.icon-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.icon-flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.icon-flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n/*------------------------\n\ticons\n-------------------------*/\n\n.icon-cloud-download-95::before {\n  content: \"\\ea02\";\n}\n\n.icon-home-minimal::before {\n  content: \"\\ea03\";\n}\n\n.icon-single-04::before {\n  content: \"\\ea04\";\n}\n\n.icon-users-mm::before {\n  content: \"\\ea05\";\n}\n\n.icon-webpage::before {\n  content: \"\\ea06\";\n}\n\n.icon-layout-25::before {\n  content: \"\\ea07\";\n}\n\n.icon-analytics::before {\n  content: \"\\ea08\";\n}\n\n.icon-chart-pie-36::before {\n  content: \"\\ea09\";\n}\n\n.icon-chart-bar-33::before {\n  content: \"\\ea0a\";\n}\n\n.icon-single-copy-06::before {\n  content: \"\\ea0b\";\n}\n\n.icon-home::before {\n  content: \"\\ea0c\";\n}\n\n.icon-single-content-03::before {\n  content: \"\\ea0d\";\n}\n\n.icon-bell-53::before {\n  content: \"\\ea0e\";\n}\n\n.icon-email-84::before {\n  content: \"\\ea0f\";\n}\n\n.icon-send::before {\n  content: \"\\ea10\";\n}\n\n.icon-at-sign::before {\n  content: \"\\ea11\";\n}\n\n.icon-attach-87::before {\n  content: \"\\ea12\";\n}\n\n.icon-edit-72::before {\n  content: \"\\ea13\";\n}\n\n.icon-tail-right::before {\n  content: \"\\ea14\";\n}\n\n.icon-minimal-right::before {\n  content: \"\\ea15\";\n}\n\n.icon-tail-left::before {\n  content: \"\\ea16\";\n}\n\n.icon-minimal-left::before {\n  content: \"\\ea17\";\n}\n\n.icon-tail-up::before {\n  content: \"\\ea18\";\n}\n\n.icon-minimal-up::before {\n  content: \"\\ea19\";\n}\n\n.icon-minimal-down::before {\n  content: \"\\ea1a\";\n}\n\n.icon-tail-down::before {\n  content: \"\\ea1b\";\n}\n\n.icon-settings-gear-64::before {\n  content: \"\\ea1c\";\n}\n\n.icon-settings::before {\n  content: \"\\ea1d\";\n}\n\n.icon-menu-dots::before {\n  content: \"\\ea1e\";\n}\n\n.icon-menu-left::before {\n  content: \"\\ea1f\";\n}\n\n.icon-funnel-40::before {\n  content: \"\\ea20\";\n}\n\n.icon-filter::before {\n  content: \"\\ea21\";\n}\n\n.icon-preferences-circle::before {\n  content: \"\\ea22\";\n}\n\n.icon-check-2::before {\n  content: \"\\ea23\";\n}\n\n.icon-cart-simple::before {\n  content: \"\\ea24\";\n}\n\n.icon-cart-9::before {\n  content: \"\\ea25\";\n}\n\n.icon-card-update::before {\n  content: \"\\ea26\";\n}\n\n.icon-basket::before {\n  content: \"\\ea27\";\n}\n\n.icon-check-circle-07::before {\n  content: \"\\ea28\";\n}\n\n.icon-simple-remove::before {\n  content: \"\\ea29\";\n}\n\n.icon-circle-remove::before {\n  content: \"\\ea2a\";\n}\n\n.icon-alert-circle-exc::before {\n  content: \"\\ea2b\";\n}\n\n.icon-bug::before {\n  content: \"\\ea2c\";\n}\n\n.icon-share-66::before {\n  content: \"\\ea2d\";\n}\n\n.icon-time-3::before {\n  content: \"\\ea2e\";\n}\n\n.icon-time::before {\n  content: \"\\ea2f\";\n}\n\n.icon-coffee::before {\n  content: \"\\ea30\";\n}\n\n.icon-smile::before {\n  content: \"\\ea31\";\n}\n\n.icon-sad::before {\n  content: \"\\ea32\";\n}\n\n.icon-broken-heart::before {\n  content: \"\\ea33\";\n}\n\n.icon-heart-2::before {\n  content: \"\\ea34\";\n}\n\n.icon-pin-3::before {\n  content: \"\\ea35\";\n}\n\n.icon-marker-3::before {\n  content: \"\\ea36\";\n}\n\n.icon-globe-2::before {\n  content: \"\\ea37\";\n}\n\n.icon-world-2::before {\n  content: \"\\ea38\";\n}\n\n.icon-phone-2::before {\n  content: \"\\ea39\";\n}\n\n.icon-check-square-11::before {\n  content: \"\\ea3a\";\n}\n\n.icon-wallet-90::before {\n  content: \"\\ea3b\";\n}\n\n.icon-credit-card::before {\n  content: \"\\ea3c\";\n}\n\n.icon-payment::before {\n  content: \"\\ea3d\";\n}\n\n.icon-tag::before {\n  content: \"\\ea3e\";\n}\n\n.icon-tag-cut::before {\n  content: \"\\ea3f\";\n}\n\n.icon-tag-content::before {\n  content: \"\\ea40\";\n}\n\n.icon-flag-diagonal-33::before {\n  content: \"\\ea41\";\n}\n\n.icon-triangle-right-17::before {\n  content: \"\\ea47\";\n}\n\n.icon-puzzle-10::before {\n  content: \"\\ea48\";\n}\n\n.icon-triangle-right-17-2::before {\n  content: \"\\ea49\";\n}\n\n.icon-btn-play::before {\n  content: \"\\ea4a\";\n}\n\n.icon-btn-play-2::before {\n  content: \"\\ea4b\";\n}\n\n.icon-menu-34::before {\n  content: \"\\ea4c\";\n}\n\n.icon-menu-left-2::before {\n  content: \"\\ea4d\";\n}\n\n.icon-heart-2-2::before {\n  content: \"\\ea4e\";\n}\n\n.icon-single-04-2::before {\n  content: \"\\ea4f\";\n}\n\n.icon-users-mm-2::before {\n  content: \"\\ea50\";\n}\n\n.icon-l-settings::before {\n  content: \"\\ea51\";\n}\n\n.icon-book-open-2::before {\n  content: \"\\ea52\";\n}\n\n.icon-layers-3::before {\n  content: \"\\ea53\";\n}\n\n.icon-logo-fb-simple::before {\n  content: \"\\ea55\";\n}\n\n.icon-logo-twitter::before {\n  content: \"\\ea56\";\n}\n\n.icon-google::before {\n  content: \"\\ea57\";\n}\n\n.icon-logo-pinterest::before {\n  content: \"\\ea58\";\n}\n\n.icon-logo-instagram::before {\n  content: \"\\ea59\";\n}\n\n.icon-logo-dribbble::before {\n  content: \"\\ea5a\";\n}\n\n.icon-tablet-mobile::before {\n  content: \"\\ea5b\";\n}\n\n.icon-house-search-engine::before {\n  content: \"\\ea5c\";\n}\n\n.icon-house-pricing::before {\n  content: \"\\ea5d\";\n}\n\n.icon-pulse-chart::before {\n  content: \"\\ea5e\";\n}\n\n.icon-plug::before {\n  content: \"\\ea5f\";\n}\n\n.icon-app-store::before {\n  content: \"\\ea60\";\n}\n\n.icon-power-level::before {\n  content: \"\\ea61\";\n}\n\n.icon-window-add::before {\n  content: \"\\ea62\";\n}\n\n.icon-form::before {\n  content: \"\\ea63\";\n}\n\n.icon-folder-15::before {\n  content: \"\\ea64\";\n}\n\n.icon-lock::before {\n  content: \"\\ea65\";\n}\n\n.icon-unlocked::before {\n  content: \"\\ea66\";\n}\n\n.icon-e-reader::before {\n  content: \"\\ea67\";\n}\n\n.icon-layout-grid::before {\n  content: \"\\ea68\";\n}\n\n.icon-single-copies::before {\n  content: \"\\ea69\";\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
